import _ from 'lodash';
const localizationMap: Map<string, any> = new Map();

const LocalizationMisc = {
  setLocal( key: string, obj: any ) {
    localizationMap.set( key, obj.language );
  },
  local( path: string, key = 'streaming' ){
    if ( !localizationMap.has( key ) ) {
      console.warn(`LocalizationMisc is missng key ${key}`);
      return path;
    }
    return _.get( localizationMap.get( key ), path, path );
  }
}

export default LocalizationMisc;